var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignNoDocs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 463 492",
    style: {
      enableBackground: "new 0 0 463 492"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#C9D9E8;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#B28B67;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#191847;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#2F3676;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#E4E4E4;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#997659;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#5C63AB;}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#DDE3E9;}\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill-opacity:0.1;}\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;fill-opacity:0.2;}\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:#F2F2F2;}\n\t.st11{fill-rule:evenodd;clip-rule:evenodd;fill:#AFB9C5;}\n\t.st12{fill-rule:evenodd;clip-rule:evenodd;fill:#C5CFD6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "st0",
    cx: 231,
    cy: 231,
    r: 229
  }), /*#__PURE__*/React.createElement("g", {
    id: "A-Human_x2F_Standing",
    transform: "translate(141.000000, 63.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(82.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(54.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.1,9.1c5.8,10.8,5.1,38.2-2.4,40.1c-3,0.8-9.3-1.1-15.8-5L24,73H0l8.3-38.5c-4.6-5.4-7.7-12-7.2-19.5 C2.6-6.4,32.3-1.7,38.1,9.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Hair",
    className: "st2",
    d: "M79.1,29.6c6.7,0.6,12.7,2.6,14.5,3.9c0,6.4-1.2,8.3-11.8,8.1c-2.6,1.4-4.6,3.7-6.7,6.8 c0.9,12.8,3.3,19.2,7.3,19.2c5.9,0,10.9-3.8,13.5-3.8c1.9,0,1.5,2.4,0.2,4.1c-1,1.4-6.1,2.8-6.1,5.1c0,1.2,1.1,1.3,2.1,1.3l0.5,0 c0.8,0,1.4,0,1.4,0.6c0,2.2,0.7,6.3-3.1,6.3c-3.9,0-15-1.4-16.9-7.1c-1.2-3.7-2-11.4-2.4-23c-0.2,0-0.5,0-0.7,0c-3.3,0-6,2.7-6,6 c0,1.7,0.7,3.2,1.8,4.3c-1.4,2-2.9,4-4.7,6.1c-6.7-4-11.7-15.8-5.1-27.1c1.8-5.5,5.9-8.5,10.7-9.9C71.6,28.8,75.7,28.6,79.1,29.6 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1_",
    transform: "translate(0.000000, 187.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Leg",
    className: "st1",
    d: "M116.6,0c1.8,24.6,118,97.1,118.6,99.1c0.3,0.9-11.8,29.5-36.2,85.7l10.2,3.9 c37.4-59.5,55.2-92.5,53.3-98.8c-2.8-9.1-32.8-39-90.1-89.6L116.6,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pant",
    className: "st3",
    d: "M201.8,172.1l16.6,6c35-39.4,48.7-72,46.2-88.6c-1.7-11.1-31.6-40.9-89.8-89.5l-59.3,0 c2,57,109.7,99.3,111.1,101.7C228,104.2,213.9,128,201.8,172.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Right-Show",
    transform: "translate(192.883915, 167.279121)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.500000, 20.000000) rotate(20.000000) translate(-30.500000, -20.000000) "
  }, /*#__PURE__*/React.createElement("path", {
    id: "shoe",
    className: "st4",
    d: "M2.7,25.4c-1.1,3-1.7,5.2-1.7,6.7c0,1.8,0.3,4.4,0.9,7.9c2.1,0,20.9,0,56.4,0 c1.5-4.8,0.6-7.5-2.5-7.8c-3.2-0.4-5.8-0.7-7.9-1L21.7,19.4c-0.5-0.2-1.1,0-1.3,0.5c0,0,0,0,0,0L18.7,24l0,0 c-2.9,1.4-5.3,2-7.1,2c-1.5,0-3.5-0.6-6.2-1.8l0,0c-1-0.5-2.2,0-2.7,1C2.7,25.3,2.7,25.4,2.7,25.4z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Leg_1_",
    className: "st5",
    points: "130,0 78.3,124.2 27.4,229.3 39.4,229.3 170.7,0  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "shoe_1_",
    transform: "translate(24.000000, 199.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2.7,25.4c-1.1,3-1.7,5.2-1.7,6.7c0,1.8,0.3,4.4,0.9,7.9c2.1,0,20.9,0,56.4,0c1.5-4.8,0.6-7.5-2.5-7.8 c-3.2-0.4-5.8-0.7-7.9-1L21.7,19.4c-0.5-0.2-1.1,0-1.3,0.5c0,0,0,0,0,0L18.7,24l0,0c-2.9,1.4-5.3,2-7.1,2 c-1.5,0-3.5-0.6-6.2-1.8l0,0c-1-0.5-2.2,0-2.7,1C2.7,25.3,2.7,25.4,2.7,25.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pant_1_",
    className: "st6",
    d: "M32,207.4l26.7,5C79.3,182.1,165.5,57.9,175,0h-59.4C84.1,41.8,51.6,176.6,32,207.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2_",
    transform: "translate(22.000000, 82.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skin",
    className: "st1",
    d: "M68.3,93l20.9,0.1c-10.7,34.6-17.3,55.7-19.9,63.3l-0.3,0.8c-0.4,1.1-0.6,1.9-0.8,2.2 c-2.3,5.7,2.6,14.5,4.7,19.2c-6.8,3.1-6.1-8.3-14.7-4.2c-1.7,0.8-3.4,1.8-5,2.7l-0.5,0.3c-0.2,0.1-0.4,0.2-0.5,0.3l-0.5,0.3 c-5,2.9-9.9,5-16.3,1c-1.1-0.7-2.3-3.3,0.6-5.3c2.2-1.5,4.8-3.4,7.2-5.4l0.7-0.6c5.4-4.3,10.5-8.9,11.4-10.8 C57.4,152.9,61.7,131.6,68.3,93L68.3,93z M194,89.1l28.3,27.6c8.2,3.5,15,7.4,20.3,11.6c1.2,1.4,2.5,4.2-3.1,2.9 c-0.5-0.1-1.1-0.2-1.6-0.3l-0.6-0.1c-4.8-1-9.4-1.5-10.3,0c-1,1.8,2,4.6,0.1,7c-1.3,1.6-5.6-3.4-13-15.1l-29.5-17.4L194,89.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Coat-Back",
    className: "st2",
    d: "M127.7,5.3l8.6-1.5c14.9,37.2,40.9,71,78,101.4l-28,34.1C149.2,96,126.3,51.4,127.7,5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shirt",
    className: "st7",
    d: "M90,114h77c-17.8-43.4-26.8-80.2-26.8-110.5L117,0C98.8,29.4,93.6,65.5,90,114z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Coat-Front",
    className: "st3",
    d: "M118,0c1.8,0.1,4.6,0.2,8.3,0.3l0,0l5.6,16c0.6,19.6,4.1,59,10.4,118.2l0,0l-50.5,0 c0.1,4.1,0.4,8.2,0.7,12.4l0,0H55C60.6,83.7,81.1,34.7,116.5,0l0,0l0,0l0,0H118z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shade",
    className: "st8",
    d: "M106,135l-14.1,0c-0.6-18.4,0.5-35.9,3.3-52.8C96.6,107.7,100.2,125.3,106,135z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Light",
    className: "st9",
    points: "103.1,104 128,92.4 128,104  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Clock",
    transform: "translate(2.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Clock-Frame",
    className: "st10",
    cx: 53,
    cy: 53,
    r: 53
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Time",
    className: "st8",
    cx: 53,
    cy: 11,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Time_1_",
    className: "st8",
    cx: 11,
    cy: 53,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Time_2_",
    className: "st8",
    cx: 95,
    cy: 53,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Time_3_",
    className: "st8",
    cx: 53,
    cy: 95,
    r: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Hand",
    className: "st11",
    points: "53,17 55,52 51,52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Hand_1_",
    className: "st11",
    points: "70.7,70.7 52.3,55.1 55.1,52.3  "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Time_4_",
    className: "st12",
    cx: 53,
    cy: 53,
    r: 4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignNoDocs);
export default __webpack_public_path__ + "static/media/sign-noDocs.eabeafdba24a4f418294a5cc32032d10.svg";
export { ForwardRef as ReactComponent };